import { useEffect } from "react";
import { useLocation } from "react-router";
import { flushIdentity, installMetaPixel, metaPixelId } from "@/lib/meta-pixel";

/** PageView on the app, including client navigations. Staff admin screens are left out. */
export function MetaPixel() {
  const { pathname } = useLocation();

  useEffect(() => {
    const id = metaPixelId();
    if (!id || pathname.startsWith("/admin")) return;
    if (!window.fbq) {
      installMetaPixel(id);
      flushIdentity();
      return;
    }
    window.fbq("track", "PageView");
  }, [pathname]);

  return null;
}
